
import { Options, Vue } from 'vue-class-component';
import { PropSync, Watch } from 'vue-property-decorator';

@Options({
	name: 'CreateGroupClass',
})
export default class CreateGroupClass extends Vue {
	@PropSync('error', { default: '' })
	error!: any;

	@PropSync('inProgress', { default: false, type: Boolean })
	inProgress!: boolean;

	group = {
		enabled: true,
		name: '',
	};

	errorMes = {
		name: '',
		status: true,
	};

	@Watch('error')
	onErrorPropsChange(value: any) {
		if (value && value['name'] && this.group.name.length) {
			this.errorMes['name'] =
				'Tên thư viện mới không được trùng với tên thư viện Đôđã có trước đó.';
		}
	}

	//----------------------- 🤍 Methods 🤍 -----------------------//
	submit() {
		this.errorMes = {
			name: '',
			status: true,
		};
		if (this.group['name']?.length <= 0 && !this.group.name?.length) {
			this.errorMes['name'] = 'Tên thư viện không được bỏ trống';
			this.errorMes.status = true;
			setTimeout(() => {
				this.errorMes = {
					name: '',
					status: true,
				};
			}, 3000);
		}
		this.$emit('submit', this.group);
	}
}
